import Select, { OldSelectProps } from 'components/atoms/inputs/OldSelect'
import { WrappedFieldProps, WrappedFieldInputProps } from 'redux-form'
import { State } from 'interfaces/state'
import { prepareFieldErrors } from 'helpers/formHelpers'

type OldSelectReusedProp =
  | 'options'
  | 'label'
  | 'theme'
  | 'isLoading'
  | 'qaMarker'
  | 'hint'
  | 'allowOuterScroll'
  | 'autoFocus'
  | 'withBorder'

export type OldSelectOwnProps<TValue> = Pick<OldSelectProps<TValue>, OldSelectReusedProp>

export type OldSelectWrappedProps<TValue> = WrappedFieldProps<State> & OldSelectOwnProps<TValue>

const normalizeSelectValue = (value: any) =>
  value === '' ? null : value

/**
 * @deprecated
 * Use Select with react-hook-form
 */
function OldSelectWrapped<TValue> (props: OldSelectWrappedProps<TValue>) {
  const {
    meta,
    ...restProps
  } = props
  const { active, touched, error } = meta
  const input = props.input as WrappedFieldInputProps

  const value = normalizeSelectValue(input.value)
  // we should pass value through onBlur
  // because redux-form ("is a douchebag" - strikethrough)
  // requires it for starting async validation
  const onBlur = () => input.onBlur(value)

  // TS magic and bugs: remove "any" when TS will manage to generics in jsx
  const TypedSelect: new () => Select<TValue> = Select as any

  return (
    <TypedSelect
      onChange={ input.onChange as any }
      onFocus={ input.onFocus as any }
      onBlur={ onBlur }
      value={ value }
      active={ Boolean(active) }
      errors={ prepareFieldErrors(error, touched) }
      errored={ touched && !!error }
      touched={ touched }
      { ...restProps }
    />
  )
}

export default OldSelectWrapped
